function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var VARIANTS = Object.freeze({
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  DANGER: 'DANGER',
  SUCCESS: 'SUCCESS',
  DEFAULT: 'DEFAULT'
});
export var secondaryVariants = [VARIANTS.SECONDARY, VARIANTS.DEFAULT];
export var colorMap = function colorMap(theme) {
  var _Object$freeze;

  return Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, VARIANTS.PRIMARY, {
    bg: theme.button.primary.background.initial,
    foreground: theme.button.primary.foreground.initial,
    depthMode: 'shadow'
  }), _defineProperty(_Object$freeze, VARIANTS.SECONDARY, {
    bg: theme.button.secondary.background.initial,
    foreground: theme.button.secondary.foreground.initial,
    depthMode: 'shadow'
  }), _defineProperty(_Object$freeze, VARIANTS.DANGER, {
    bg: theme.button.danger.background.initial,
    foreground: theme.button.danger.foreground.initial,
    depthMode: 'shadow'
  }), _defineProperty(_Object$freeze, VARIANTS.SUCCESS, {
    bg: theme.button.success.background.initial,
    foreground: theme.button.success.foreground.initial,
    depthMode: 'shadow'
  }), _defineProperty(_Object$freeze, VARIANTS.DEFAULT, {
    bg: theme.button.default.background.initial,
    foreground: theme.button.default.foreground.initial,
    depthMode: 'shadow'
  }), _Object$freeze));
};